import type { ID } from '@octopus-do/octopus-project-core'
import { notificationActionCreators } from '@storeOld/reducers/notification'

// Toasts of the templates flows. They are actions of the legacy notification
// reducer, but they belong to this module: store_old takes nothing new.
export const TemplateSavedNotification = (id: ID) =>
  notificationActionCreators.setCustomNotification({
    type: 'topaz',
    text: 'Template saved',
    toastContainerId: 'secondary',
    actionText: 'Open',
    callback: () => window.open(`/${id}`, '_blank'),
  })

export const TemplateDeletedNotification =
  notificationActionCreators.setCustomNotification({
    type: 'topaz',
    text: 'Template deleted',
    toastContainerId: 'secondary',
  })
